import { extractCountryCode } from "./utils";
import { setTag } from "./tagMapper";
import { setDistrictData } from "./districtMapper";
import { setCampusData } from "./campusMapper";
import { isValidValue, logger } from "utils";

export const setUserData = (el = {}) => {
  try {
    const tags = (Array.isArray(el.tags) ? el.tags : []).map((e) => setTag(e));
    const districts = (Array.isArray(el.districts) ? el.districts : []).map(
      (e) => setDistrictData(e),
    );

    let building = [];
    const campuses = (Array.isArray(el.campuses) ? el.campuses : []).map(
      (campus) => {
        const campusData = setCampusData(campus);
        if (campusData.buildings.length) {
          campusData.buildings.forEach((e) => building.push(e));
        }
        return campusData;
      },
    );

    const { number, countryCode } = extractCountryCode(
      el.phone ?? el.phone_number,
    );
    return {
      id: el.ID || null,
      first_name: el.first_name || null,
      last_name: el.last_name || null,
      name: `${((el.first_name || "") + " " + (el.last_name || "")).trim()}`,
      email: el.email || null,
      phone_number: number,
      countryCode: countryCode,
      phone: el.phone ?? el.phone_number,
      title: el.title || null,
      type: el.type || "Internal",
      auth_provider: el.auth_provider || null,
      auth_provider_id: el.auth_provider_id || null,
      is_location_enabled: el.is_location_enabled || false,
      is_camera_enabled: el.is_camera_enabled || false,
      is_microphone_enabled: el.is_microphone_enabled || false,
      is_notification_enabled: el.is_notification_enabled || false,
      note: el.note || null,
      date_of_birth: el.date_of_birth || null,
      profile_pic: el.profile_pic || null,
      is_onboarding_complete: el.is_onboarding_complete || false,
      districts,
      district_id: districts.length ? (districts?.[0]?.id ?? null) : null,
      campuses,
      building,
      tags,
      role: el.role || null,
      role_id: el.role_id || null,
      role_name: el.role_name || "",
      notes: el.note || "",
      admin_panel_access: el.admin_panel_access || false,
      toc_desktop_app_access: el.toc_desktop_app_access || false,
      end_user_mobile_app_access: el.end_user_mobile_app_access || false,
      district_setup_access: el.district_setup_access || false,
      inviteStatus: isValidValue(el.first_name) ? "active" : "never_onboarded",
    };
  } catch (error) {
    logger.error("Error in setUserData:", error, el);
    throw error;
  }
};
